import { defaultQueryOptions } from 'constants/'
import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { QueryOptions } from 'types'
import { logFactory } from 'utils'
import { CustomerSearchQuery, useCustomersService } from '../services'
import { useIsIgnoringDeliveryModel } from '../useIsIgnoringDeliveryModel'

const hookName = 'useCustomerSearch'
const log = logFactory(hookName)
const searchDefaultPageSize = 10

const useCustomerSearch = (query: CustomerSearchQuery, options: QueryOptions = { enabled: true }) => {
  const { searchCustomers } = useCustomersService()
  const isIgnoringDeliveryModel = useIsIgnoringDeliveryModel()

  const params = useMemo(
    () => ({
      ...query,
      ...{ deliveryModel: isIgnoringDeliveryModel ? undefined : query.deliveryModel },
    }),
    [isIgnoringDeliveryModel, query]
  )

  const doQuery = async () => {
    log(`🫂 Searching customers...`, query)

    const { data, meta } = await searchCustomers({
      pageSize: searchDefaultPageSize,
      sort: 'DESC',
      sortBy: 'createdAt',
      ...params,
    })

    log(`🫂 Found ${data.length} customers`, data)

    return { data, meta }
  }

  return useQuery([hookName, params], doQuery, {
    ...defaultQueryOptions,
    ...options,
  })
}

export { useCustomerSearch }
